import { Component, ViewEncapsulation, OnInit, Injector,  OnDestroy, Inject} from '@angular/core';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { ActivatedRoute ,Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { AirModel } from 'src/app/models/air/air-model';
import { ListService } from 'src/app/services/list/list.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectBoxItemService } from 'src/app/services/select-box-item.service';
import { SearchDetailDialog } from 'src/app/components/search-detail-dialog/search-detail-dialog.component';
import { changeDueSub } from 'src/app/components/due-component/due-component.component';
import { TrackingeComponent } from '../tracking/tracking/tracking.component';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { ClickHistorySubject } from 'src/app/events/click-history.events';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { SeaPriceRequestComponent } from '../sea/price-request/price-request.component';
import { SeaPriceActionService } from 'src/app/services/sea/sea-price-action.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class ListComponent extends BaseFormComponentComponent implements OnInit, OnDestroy {

  // @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  stickyPanel: HTMLElement;
  showDialog: boolean = false;
  dialogHeader: string = "Quote No";
  page: number = 0;
  totalCount: any = 0;
  optionButtonsReady: any[];
  hasOperation: boolean = false;
  rows: number = 20;
  first: number = 0;


  optionButtons: any[] = [
    {label: 'airMenu', value: 'AIR'},
    {label: 'seaMenu', value: 'SEA'},
    {label: 'landMenu', value: 'TRUCK', inactive: true}
  ];
  trackingDialogRef: DynamicDialogRef;

  menuItems: MenuItem[] = [
    {
      label:'View',
      icon:'pi pi-fw pi-eye',
      command: () => this.view(this.selectedResultItem)
   }
  ]

  isLoading: boolean = true;
  selectedListOpiton: string = "AIR";
  selectedListOperationType: string = null;
  selectedFilterOption: string = "all";
  searchResult: any[] = [];
  selectedResultItem: any;
  airModel: AirModel;
  searchDetailDialogRef: DynamicDialogRef;
  activeOperationInRoute: string = "";
  isOperation: boolean = false;

  constructor(protected injector: Injector, private airService: AirSearchService, private seaService: SeaSearchService,
    private priceActionService: SeaPriceActionService,
     private selectBoxItemService: SelectBoxItemService, private listService: ListService, public activatedRoute: ActivatedRoute, public router: Router) {
    super(injector);
  }



  async ngOnInit() {

    
    for (const e of this.optionButtons) {
        e.label = await this.translation.get(e.label).toPromise();
    }
    this.optionButtonsReady = this.optionButtons;

      //get selectbox items
    await this.selectBoxItemService.getItemsAndSaveLocalStorage("marketShipmentStatus");
    await this.selectBoxItemService.getItemsAndSaveLocalStorage("marketOfferSubStatus");


    this.hasOperation = ['inProgressOperation', 'completedOperations', 'cancelled'].includes(this.activatedRoute.snapshot.params.type);
    this.isOperation = this.activatedRoute.snapshot.params.type == 'inProgressOperation';
    this.activeOperationInRoute = this.activatedRoute.snapshot.queryParams.operation;

    this.loadList(this.activeOperationInRoute.toUpperCase());

    // url değişirse listeyi çağır.
    // this.activatedRoute.url.subscribe((s) => {

      
    //   if(this.activatedRoute.snapshot.queryParams.operation != this.activeOperationInRoute) {
    //     this.activeOperationInRoute = this.activatedRoute.snapshot.queryParams.operation;
    //     this.loadList(this.activatedRoute.snapshot.queryParams.operation.toUpperCase());
    //   } else {
    //     this.loadList(this.activatedRoute.snapshot.queryParams.operation.toUpperCase());
    //   }


    // })

    // Query params değişirse listeyi çağır.
    this.activatedRoute.queryParams.subscribe(p => {

      if(p.operation != this.activeOperationInRoute) {
        this.loadList(p.operation)
        this.activeOperationInRoute = p.operation;
      }

      this.activeOperationInRoute = null;

    });



    changeDueSub.subscribe(s => {
      if(this.searchResult) { this.onChangeOption(this.selectedListOpiton); }
    })

  }

  ngOnDestroy(): void {
    if(changeDueSub) changeDueSub.unsubscribe();
  }

  loadList(operation) {
    
    if(operation == 'SEA') {
      this.onChangeOption("SEA")
    }
    if(operation == 'AIR') {
      this.onChangeOption("AIR")
    }

  }
  onRowSelect(event) {
    this.selectedResultItem = event;

  }


  async view(item) {

    let viewType;
    
    switch(this.activatedRoute.snapshot.params.type) {
      case 'notReservedList':
        viewType = 'dash1'
        break;
      case 'reservation':
        viewType = 'dash2'
        break;
      case 'inProgressOperation':
          viewType = 'dash3'
        break;
      case 'completedOperations':
        viewType = 'dash4'
        break;
    }

    const historyModel = new SearchLogClickHistoryModel();
    historyModel.viewType = viewType;
    historyModel.productName = 'main-dashboard'
    historyModel.info =  item.quoteNo
    historyModel.costType = this.selectedListOpiton;
    ClickHistorySubject.next(historyModel);
      
                 

    try{
        this.toggleLoadingProgress();

        if (this.selectedListOpiton === 'AIR'){
        
          if(['inProgressOperation', 'completedOperations', 'cancelled'].includes(this.activatedRoute.snapshot.params.type)) {
            this.showTracking(item, "AIR");
          } else {
            this.showDetailDialog(item, "AIR");
          }

        } else if (this.selectedListOpiton === 'SEA') {

          if('notReservedList' == this.activatedRoute.snapshot.params.type) {

            try {
              const searchModelResp = await this.seaService.get(item.id).toPromise();
              searchModelResp.productName = item.productName;
            
              await this.priceActionService.openPriceInfo(searchModelResp.selectedProduct, searchModelResp, this, true);
              this.toggleLoadingProgress();
            } catch (error) {
                console.error('Hata oluştu:', error);
                this.toggleLoadingProgress();
            }
            return;


          }

          if(['inProgressOperation', 'completedOperations', 'cancelled'].includes(this.activatedRoute.snapshot.params.type)) {
            this.showTracking(item, "SEA");
          } else {
            this.showDetailDialog(item, "SEA");
          }

        }
      this.toggleLoadingProgress();
    } catch {
      this.toggleLoadingProgress();
    }
  }

  async showTracking(item, operation) {
    this.trackingDialogRef = this.dialogService.open(TrackingeComponent, {  header: item.shipmentNo || item.quoteNo,  width: '100%',  height: '100vh', contentStyle: {"overflow": "auto"}, modal:true,  closable: true,  
      data: {
        searchText: (item.shipmentNo ?? item.quoteNo),
        operation: {code: operation}
      } 
    
    });
  }

  
  async showDetailDialog(item, operation) {
    this.searchDetailDialogRef = await this.dialogService.open(SearchDetailDialog,{ header: null, showHeader: false, modal: true, width: '90vw', height:'100vh', closable: false, data: {operation: operation, id: item.id} });
  }




  async getSegment(airModel: AirModel) {
    if(airModel.arrivalPort && airModel.departurePort) {
      return await this.airService.segment(airModel.departurePort.id, airModel.arrivalPort.id).toPromise();
    }
    return null;
  }


  async getAirList(page?: number) {
    try {
      this.isLoading = true;
      switch(this.activatedRoute.snapshot.params.type) {

        case 'notReservedList':
           await this.listService.getList(this.activatedRoute.snapshot.params.type, 'air', page).subscribe(res =>{
              this.totalCount = res.headers.get('Total-Elements');
              this.searchResult = res.body;
              this.isLoading = false;
          })
          break;
        case 'cancelled':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'air', page).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        case 'reservation':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'air', page).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        case 'inProgressOperation':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'air', page).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        case 'completedOperations':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'air', page).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        default:
          this.isLoading = true;
          return;
      }
    } catch {
      this.isLoading = false;
    }


  }


  async getSeaList(page?: number) {
    try {
      
      this.isLoading = true;
      switch(this.activatedRoute.snapshot.params.type) {
      case 'notReservedList':
       await this.listService.getList(this.activatedRoute.snapshot.params.type, 'sea', page, this.selectedListOperationType).subscribe(res => {
        this.totalCount = res.headers.get('Total-Elements');
        const rawData = res.body;

        if (this.selectedListOpiton === 'SEA' && rawData) {
            const groups = new Map<number, any[]>();
            
            // 1. Tüm veriyi searchLog'a göre grupla
            rawData.forEach(item => {
                if (!groups.has(item.searchLog)) {
                    groups.set(item.searchLog, []);
                }
                groups.get(item.searchLog).push({ ...item });
            });

            const finalResult = [];

            // 2. Her grup için istisnasız bir Master oluştur
            groups.forEach((items, logId) => {
                // İlk kaydı Master şablonu için baz alıyoruz
                const firstItem = items[0];
                finalResult.push({
                    ...firstItem, 
                    // Tek kayıt olsa bile artık true çekiyoruz ki Master tasarımı çalışsın
                    isMultipleRequest: true, 
                    requests: items 
                });
            });

            this.searchResult = finalResult;
        } else {
            this.searchResult = rawData;
        }
        
        console.log(this.searchResult, "this.searchResult")
        this.isLoading = false;
    });
            break;
        case 'cancelled':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'sea', page,  this.selectedListOperationType).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        case 'reservation':
            await this.listService.getList(this.activatedRoute.snapshot.params.type, 'sea', page,  this.selectedListOperationType).subscribe(res =>{
                this.totalCount = res.headers.get('Total-Elements');
                this.searchResult = res.body;
                this.isLoading = false;
            });
            break;
        case 'inProgressOperation':
              await this.listService.getList(this.activatedRoute.snapshot.params.type, 'sea', page,  this.selectedListOperationType).subscribe(res =>{
                  this.totalCount = res.headers.get('Total-Elements');
                  this.searchResult = res.body;
                  this.isLoading = false;
              });
              break;
        case 'completedOperations':
              await this.listService.getList(this.activatedRoute.snapshot.params.type, 'sea', page,  this.selectedListOperationType).subscribe(res =>{
                  this.totalCount = res.headers.get('Total-Elements');
                  this.searchResult = res.body;
                  this.isLoading = false;
              });
              break;
        default:
          this.isLoading = true;
          return;
      }
    } catch {
      this.isLoading = false;
    }


  }

 async onChangeOption(operation: string, operationType: string = null) {
    this.first = 0;
    this.searchResult = [];
    this.selectedListOpiton = operation;
    this.selectedListOperationType = operationType;
    switch(operation) {
      case 'AIR':
        await this.getAirList(0);
        break;
      case 'SEA':
        await this.getSeaList(0);
        break;
      default:
        this.isLoading = false;
        return;
    }

  }

  redirectHome() {
    this.router.navigateByUrl('/home');
  }

    onPage(event: any) {
      if (this.selectedListOpiton === 'AIR'){
          this.getAirList(event.first / 20);
      }else if (this.selectedListOpiton === 'SEA'){
          this.getSeaList(event.first / 20);
      }
    }



get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalCount / this.rows));
}

get currentPage(): number {
    return Math.floor(this.first / this.rows);
}

changePage(pageNumber: number) {
    if (pageNumber < 0 || pageNumber >= this.totalPages) return;
    const safePageNumber = Math.round(pageNumber); 
    this.first = safePageNumber * this.rows;

    const event = {
        first: Math.floor(this.first),
        rows: Math.floor(this.rows),
        page: safePageNumber
    };
    
    console.log("İstek gönderiliyor - Sayfa:", safePageNumber, "First:", this.first); // Debug için
    this.onPage(event);
}

get pageNumbers(): number[] {
    const pages = [];
    for (let i = 0; i < this.totalPages; i++) {
        pages.push(i);
    }
    return pages;
}

}
